import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["elementToScroll"]

  scrollTo() {
    this.elementToScrollTarget.scrollIntoView();
  }
}
